import moment from 'moment';

import admissionGroupStatService from 'src/api/admissionGroupStat';

function EventDashboardCtrl($scope, $state, $stateParams, imgixService, $q, sdkVenueService, eventService, sdkUtils, dateUtilsService,
  alertService, managementUserService, ERROR_MESSAGES, organizationService, mapperService, venueService, urlService, sdkBookingService,
  modalService, managementUserOrganizationMemberService, admissionGroupService, visibilityHelpersService) { //eslint-disable-line
  const vm = this;

  const currentUserOrganization = organizationService.getCurrentOrganization();
  const organizationMember = managementUserOrganizationMemberService.getCurrentOrganizationMember();

  vm.currentDateUTC = moment.utc();
  vm.loading = true;
  vm.venueId = $stateParams.venueId;
  vm.linkCopied = function($event) {
    if ($event) $event.preventDefault();

    vm.eventForm.showCopiedTooltip = true;
  };

  vm.isVenuePrivate = function(venue) {
    return visibilityHelpersService.isPrivate(venue);
  };

  vm.eventHasPassed = function(event) {
    if (!event) return true;

    const now = moment().startOf('day');

    const eventDate = event.date.startOf('day');

    return eventDate.diff(now, 'days') < 0;
  };

  vm.getEventImage = function() {
    if (!vm.eventForm || !vm.eventForm.primaryImage) return '';

    return imgixService.url(vm.eventForm.primaryImage, {
      width: 90,
      height: 90
    });
  };

  vm.isPublished = function(event) {
    if (!event) return null;

    const now = moment().startOf('day');

    const eventDate = event.date.startOf('day');

    return visibilityHelpersService.isPublished(event) && eventDate.diff(now, 'days') >= 0;
  };

  vm.getEventScheduledText = function(event) {
    if (!event) return '';

    if (!event.enabledOn) return false;

    if (!visibilityHelpersService.isPublished(event)) return false;

    return event.enabledOn.isAfter(moment());
  };

  vm.showEventScheduledText = function() {
    if (!vm.eventForm) return '';

    if (!vm.eventForm.enabledOn) return false;

    if (!visibilityHelpersService.isPublished(vm.eventForm)) return false;

    return vm.eventForm.enabledOn.isAfter(moment());
  };

  vm.publish = function(val, cb) {
    let modalInstance;
    return modalService.confirmation({
        modalHeader: val ? 'Publish?' : 'Unpublish',
        modalMessage: val ? 'Are you sure you want to publish? This will make your event live.' : `Are you sure you want to unpublish?
If you already have orders for this event be sure to refund them.`,
        confirmBtnTxt: val ? 'Publish' : 'Unpublish',
        confirmingBtnTxt: 'Saving...',
        confirmingBtnClass: val ? 'btn-success' : 'btn-secondary',
        hideCancelBtn: true
      })
      .then(result => {
        modalInstance = result.modalInstance;

        if (result) {
          const eventData = {
            visibility: val && result.confirm ? visibilityHelpersService.VISIBILITY_TYPES.PUBLISHED.value : visibilityHelpersService.VISIBILITY_TYPES.PUBLIC.value
          };

          const saveEventPromise = result.confirm ?
            eventService.updateById(vm.eventForm.id, eventData) :
            eventService.createByOrganizationId(currentUserOrganization.id, eventData);

          return saveEventPromise
            .then(updatedEvent => {
              vm.eventForm = mapperService.mapEventToUI(updatedEvent);

              return cb(true);
            });
        }

        return cb(false);
      })
      .finally(() => modalInstance.close())
      .catch(error => {
        if (typeof error === 'string') return alertService.error(error);
        if (error.message) return alertService.error(error.message);
        return alertService.error(sdkUtils.getErrorFromResponse(error));
      });
  };

  const dataPromises = [
    $scope.venuePromise,
    $scope.eventPromise
  ];

  $q.all(dataPromises)
    .then(results => {
      vm.venue = results[0];
      vm.event = results[1];
      vm.admissionGroups = results[2];

      const mappedEvent = mapperService.mapEventToUI(results[1]);

      const seoPathname = (mappedEvent.seoPathname) ? mappedEvent.seoPathname : mappedEvent.id;

      mappedEvent.publicPageURL = urlService.getEventPublicPageUrl(seoPathname, {
        venue: vm.venueId,
        attributionId: organizationMember.id
      });

      vm.eventForm = mappedEvent;

      vm.loading = false;

      return $q.resolve(admissionGroupStatService.findByIdAndVenueId(vm.event.date, vm.venueId));
    })
    .then(result => {
      vm.admissionGroupStats = result.data;
    });
}

EventDashboardCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  'jsSdk.imgix',
  '$q',
  'jsSdk.venue',
  'jsSdk.event',
  'jsSdk.utils',
  'dateUtilsService',
  'alertService',
  'jsSdk.managementUser',
  'ERROR_MESSAGES',
  'organizationService',
  'mapperService',
  'venueService',
  'urlService',
  'jsSdk.booking',
  'modalService',
  'managementUserOrganizationMemberService',
  'jsSdk.admissionGroup',
  'visibilityHelpersService'
];

export default EventDashboardCtrl;



// WEBPACK FOOTER //
// ./src/components/eventDashboard/eventDashboardCtrl.js